import Footer from "../ones/Footer";
import ServiceDetailContent from "../ones/ServiceDetailContent";

export default function ServiceDetail(props) {
  const { serviceSlug } = props;

  return (
    <>
      <ServiceDetailContent serviceSlug={serviceSlug} />
      <Footer />
    </>
  );
}

